import { Empresa } from "../model/entities/Empresa";
import { Usuario } from "../model/entities/Usuario";
import api from "./api";

const ROUTE = "login";

class authApi {
  async login(login: string, senha: string) {
    try {
      const res = await api.post<{
        tokenJWT: string;
        usuario: Usuario;
        empresa: Empresa;
      }>(`/${ROUTE}`, { login, senha });

      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiAuth = new authApi();
export default apiAuth;
